'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Breakpoints Class --------------------//

// usage: helper functions to test viewport size @ exact match w/ css
// window.matchMedia alternative
//
// Breakpoints({
// 	breakpoints: ['sm'],
//  element: $('body')[0]
// })
//


var defaultBreakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
    defaultElement = document.querySelector('body'),
    getCurrent = function getCurrent() {
	return window.getComputedStyle(defaultElement, ':before').getPropertyValue('content').replace(/\"/g, '');
};

var currentBpIndex = null,
    initialBp = getCurrent();

var Breakpoints = function () {
	function Breakpoints(options) {
		_classCallCheck(this, Breakpoints);

		options = options || {};
		this.breakpoints = options.breakpoints || defaultBreakpoints;
		this.element = options.element || defaultElement;

		this.refreshCurrentIndex();
		this.initbp = this.getCurrent();

		if (options.evented) {
			//todo: custom event 'breakpoints.xs.down'
		}
	}

	//get value of the pseudo-element


	_createClass(Breakpoints, [{
		key: 'getCurrent',
		value: function getCurrent() {
			return window.getComputedStyle(this.element, ':before').getPropertyValue('content').replace(/\"/g, '');
		}
	}, {
		key: 'emitEvents',
		value: function emitEvents() {
			var newBp = getCurrent(),
			    currBp = this.initBp;

			if (newBp !== currBp) {
				$(window).trigger('breakpoints.change');
				currBp = newBp;
			}
		}
	}, {
		key: 'refreshCurrentIndex',
		value: function refreshCurrentIndex() {
			currentBpIndex = this.breakpoints.indexOf(this.getCurrent());
		}
	}, {
		key: 'breakpointUp',
		value: function breakpointUp(bp) {
			this.refreshCurrentIndex();
			var bpArgIndex = this.breakpoints.indexOf(bp);
			return currentBpIndex >= bpArgIndex;
		}
	}, {
		key: 'breakpointDown',
		value: function breakpointDown(bp) {
			this.refreshCurrentIndex();
			var bpArgIndex = this.breakpoints.indexOf(bp);
			return currentBpIndex <= bpArgIndex;
		}
	}, {
		key: 'breakpointBetween',
		value: function breakpointBetween(min, max) {
			this.refreshCurrentIndex();
			var bpMinIndex = this.breakpoints.indexOf(min),
			    bpMaxIndex = this.breakpoints.indexOf(max);
			return currentBpIndex >= bpMinIndex && currentBpIndex <= bpMaxIndex;
		}
	}]);

	return Breakpoints;
}();

exports.default = Breakpoints;
;


//////////////////
// WEBPACK FOOTER
// ./_js/libs/breakpoints.js
// module id = 8
// module chunks = 0